import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * トップページ　PROJECTスライダー
*/
const topProjectSlider = () => {

    const swiper = new Swiper('.js_topProjectSlider', {
        effect: "fade",
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    });
}

export default topProjectSlider;